import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api'
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('match-a_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    // Only force-redirect on 401 for authenticated requests (i.e. the token
    // we sent is no longer valid), not for login/signup calls that return 401
    // because of wrong credentials — those should surface the error message.
    const isAuthEndpoint = err.config?.url?.startsWith('/auth/');
    if (err.response?.status === 401 && !isAuthEndpoint) {
      localStorage.removeItem('match-a_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
